import jsYaml from 'js-yaml'

export function yamlToJson(allYaml) {
  const yamls = allYaml.replace(/ !!opencv-matrix/g, '').split('%YAML:1.0')
  yamls.shift()
  return yamls.map(yaml => jsYaml.load(yaml))
}
